import React, { useState, useEffect, memo } from 'react';

const TextPreview = memo(({ src, fileName }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!src) return;
    setLoading(true);
    setError(null);
    
    const MAX_PREVIEW_SIZE = 1024 * 1024; // 1MB limit for text preview
    fetch(src)
      .then(response => {
        if (!response.ok) throw new Error('Failed to load file');
        const contentLength = response.headers.get('content-length');
        if (contentLength && parseInt(contentLength) > MAX_PREVIEW_SIZE) {
          throw new Error('File too large to preview');
        }
        return response.text();
      })
      .then(text => {
        if (text.length > MAX_PREVIEW_SIZE) {
          setContent(text.substring(0, MAX_PREVIEW_SIZE) + '\n\n--- File truncated (exceeds 1MB preview limit) ---');
        } else {
          setContent(text);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Text preview error:', err);
        setError('Unable to load file content');
        setLoading(false);
      });
  }, [src]);

  if (loading) {
    return (
      <div className="u_fv-text-preview u_fv-text-preview--loading">
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="u_fv-text-preview u_fv-text-preview--error">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="u_fv-text-preview">
      <pre className="u_fv-text-content">{content}</pre>
    </div>
  );
});

export default TextPreview;
